import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Explorer from '@/components/explorer/Explorer.vue'
import Locations from '@/views/Locations'
import Menus from '@/views/Menus'
import Vocabulary from '@/views/Vocabulary'
import Vocabulary2 from '@/views/Vocabulary2'
import Sites from '@/views/Sites'
import UsersView from '@/views/Users'
import Roles from '@/views/Roles'
import Page404 from '@/views/404'
import ExplorerTable from '@/components/explorer/ExplorerTable'
import TodoListTable from '@/components/explorer/TodoListTable'
import ExplorerCalendar from '@/components/explorer/ExplorerCalendar'
import PDFViewer from '@/views/PDFViewer'
import BPExplorerTable from '@/components/bpexplorer/BPExplorerTable'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '*/logout',
      name: 'logout',
      component: () =>
        import(/* webpackChunkName: "logout" */ './views/Logout.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/processes',
      name: 'processes',
      component: () =>
        // import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/processes_old',
      name: 'processes_old',
      component: () =>
         import(/* webpackChunkName: "processes" */ './views/Processes.vue'),
        //import(/* webpackChunkName: "processes" */ './views/ProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '/subprocess',
      name: 'subprocess',
      component: () => import('./views/SubProcessMap.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: () =>
        import(/* webpackChunkName: "preferences" */ './views/Preferences.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/roles',
      name: 'roles',
      component: Roles,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: '/sites',
      name: 'sites',
      component: Sites,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/users',
      name: 'users',
      component: UsersView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/locations',
      name: 'locations',
      component: Locations,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/explorer',
      name: 'explorer',
      component: Explorer,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/explorerTable',
      name: 'explorerTable',
      component: ExplorerTable,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/explorerCalendar',
      name: 'explorerCalendar',
      component: ExplorerCalendar,
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '/menus',
      name: 'menus',
      component: Menus,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/vocabularies',
      name: 'vocabularies',
      component: Vocabulary,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: PDFViewer,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/todoList',
      name: 'todoList',
      component: TodoListTable,
      meta: {
        requiresAuth: true,
      },
    },    
    {
      path: '/BPExplorerTable',
      name: 'BPExplorerTable',
      component: BPExplorerTable,
      meta: {
        requiresAuth: true,
      },
    },
    {
      // will match everything
      path: '*',
      component: Page404,
    },
  ],
})
